<template>
  <div class="statistics-value">
    <div
      v-for="(item, index) in statistics"
      :key="index"
      class="cell"
    >
      <span>{{item.name}}</span>
      <span class="cell-enterprise dot">{{item.enterprise}}</span>
      <span class="cell-commodity dot">{{item.commodity}}</span>
      <span class="cell-query dot">{{item.query}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statistics: Array
  }
}
</script>

<style scoped>
.statistics-value {
  height: 35vh;
  overflow: hidden;
  color: #fff;
  padding-left: 5%;
  padding-right: 5%;
  box-sizing: border-box;
}
.statistics-value .cell {
  height: 7.69%;
  font-weight: bold;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.statistics-value .cell > span {
  position: relative;
  display: inline-block;
  width: 25%;
  text-align: center;
}
.statistics-value .cell > .dot::before {
  content: '';
  display: inline-block;
  width: .6vw;
  height: .6vw;
  border-radius: .3vw;
  margin-right: .2vw;
}
.cell-enterprise::before {
  background-color: #fad43c;
}
.cell-commodity::before {
  background-color: #349dfa;
}
.cell-query::before {
  background-color: #d50348;
}
</style>
